import SecurityIcon from '@material-ui/icons/Security';
import ComplaintList from './ComplaintList';

export default {
    list: ComplaintList,
    icon: SecurityIcon,
};
